<div [matMenuTriggerFor]="toolBarItemDropdown" class="ui-dropdown-menu__trigger"></div>
<mat-menu
  #toolBarItemDropdown="matMenu"
  class="ui-dropdown-menu  {{ smallWidth ? 'ui-dropdown-menu--small' : 'ui-dropdown-menu--large' }} {{ class }}"
  [overlapTrigger]="isSubMenu"
  [yPosition]="'below'"
  >
  @if (showHeader) {
    <div class="ui-dropdown-menu__header">
      <h6>
        @if (headerIcon) {
          <campus-icon class="icon" [svgIcon]="headerIcon"></campus-icon>
        }
        <strong>{{ newItemCount }} nieuwe</strong> {{ itemType }}
      </h6>
      @if (linkText && linkUrl) {
        <span>
          <a data-cy="btn-dropdown-menu-header" [routerLink]="linkUrl">{{ linkText }}</a></span
          >
        }
      </div>
    }
    <div class="ui-dropdown-menu__body"> <ng-content></ng-content> </div>
  </mat-menu>
